import React from "react";
import "./LegalContent.styles.css";

const RefundPolicyPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="cm-legal-content-container">
      <div className="inner-banner">
        <h2 className="cm-section-h cm-txt-center cm-white-col">
          Refund and Cancellation Policy
        </h2>
      </div>
      <div className="cm-section  cm-page-center cm-lr-pad">
        <ul>
          <li>
            Most airline tickets and service fees become non-refundable after 24
            hours from the time of booking.
          </li>
          <li>
            Trip protection insurance is eligible for a refund within 10 days of
            purchase, provided travel has not begun. To cancel, customers must
            contact our customer service team at{" "}
            <a href="tel:+18773279309">
              <b>(877) 400-0302</b>
            </a>
            .
          </li>
          <li>
            All cancellations must be requested via phone by contacting{" "}
            <b>Airefare</b> customer support at{" "}
            <a href="tel:+18773279309">
              <b>(877) 400-0302</b>
            </a>
            .
          </li>
          <li>
            Refund requests for airline tickets will only be considered if the
            following conditions are met:
            <ul>
              <li>
                The customer has submitted a cancellation and refund request
                through us.
              </li>
              <li>The ticket fare rules allow cancellations and refunds.</li>
              <li>
                All passengers listed on the booking are not marked as “No
                Show.”
              </li>
              <li>
                We are able to obtain a waiver from the airline to process the
                refund.
              </li>
            </ul>
          </li>
          <li>
            Please note that we cannot guarantee a specific timeframe for
            airline refund processing.
            <ul>
              <li>All refund requests are handled sequentially.</li>
              <li>
                Once a cancellation request is received, a confirmation email
                with a tracking number will be sent.
              </li>
              <li>
                This confirmation only acknowledges receipt of the request and
                does not guarantee a refund.
              </li>
              <li>
                We coordinate with airlines and suppliers to secure approvals
                and will update customers accordingly.
              </li>
              <li>
                Service fees associated with the original booking are
                non-refundable.
              </li>
            </ul>
          </li>
          <li>
            Refunds are processed in coordination with airlines and other
            suppliers.
            <ul>
              <li>
                Approved refunds may take additional time to reflect on the
                customer’s card statement.
              </li>
              <li>
                Airlines and suppliers generally apply cancellation penalties.
              </li>
              <li>
                The entire process may take approximately 60–90 days from
                request to final credit.
              </li>
              <li>
                <b>Airefare</b> may charge a post-ticketing service fee where
                applicable.
              </li>
              <li>
                All applicable fees are charged per passenger, per ticket.
              </li>
              <li>
                If a refund is not approved by the supplier, our post-ticketing
                service fee may be refunded, excluding original booking fees.
              </li>
            </ul>
          </li>
          <li>
            For security purposes, cancellations are only processed via phone at{" "}
            <a href="tel:+18773279309">
              <b>(877) 400-0302</b>
            </a>
            , and not through email or chat.
            <ul>
              <li>
                A Unique Cancellation Password will be sent to the registered
                email address.
              </li>
              <li>
                This password must be provided to our agents to complete the
                cancellation.
              </li>
              <li>
                If the customer cannot access the registered email or provide
                the password, the request may not be processed.
              </li>
              <li>
                The password expires within 3 hours. If expired, a new one must
                be requested.
              </li>
            </ul>
          </li>
          <li>
            If a ticket is canceled directly with the airline, customers must
            contact{" "}
            <a href="tel:+18773279309">
              <b>(877) 400-0302</b>
            </a>{" "}
            to request any applicable adjustments or refunds of Airefare service
            fees.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default RefundPolicyPage;
